import React, { useCallback, useRef, useState } from 'react';
import {
	ExploreButton,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMap from 'highcharts/modules/map';
import * as Highcharts from 'highcharts';
import {
	ApButtonSecondary,
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import { renderToString } from 'react-dom/server';
import Tooltip from '../Components/Tooltip';
import _ from 'lodash';
import { useFilterContext } from 'contexts/FilterContext';
import filterNames, { generateToolTip } from 'utils/filterNames';
import { MultiSelectWrapper } from '../WidgetSettings.js/WidgetSettings.styles';
import CategoryMultiSelect from 'Settings/FirstUsageSettings/CategoryMultiSelect';
import { useChartContext } from 'contexts/CategoryChartContext';
import ExpandedModal from '../Components/ExpandedModal';
import drilldown from 'highcharts/modules/drilldown.js';
drilldown(Highcharts);
HighchartsMap(Highcharts);

const BLSMsa = ({
	chartTitle,
	chartheight,
	isParent,
	chartData,
	blsStateDrilldownData,
}) => {
	const [isExpandedView, setIsExpandedView] = useState(false);
	const chartRef = useRef();
	const { state: newState, actions } = useFilterContext();
	const initialBLSStateSettings = {
		[filterNames.mapStateWorkerType]: newState.mapStateWorkerType,
		[filterNames.mapStateBLSYear]: newState.mapStateBLSYear,
	};
	const [joinBy] = useState(true);
	const { setMultipleFilters } = actions;
	const { state } = useChartContext();
	const { blsstateLoading } = state;

	const [blsStateSettings, setBLSStateSettings] = useState(
		initialBLSStateSettings
	);

	const handleChange = useCallback((evnt, action, chart) => {
		if (action === 'workerType' && chart === 'mapstates') {
			setBLSStateSettings(prev => ({
				...prev,
				[filterNames.mapStateWorkerType]: evnt,
			}));
		}
		if (action === 'blsyear' && chart === 'mapstates') {
			setBLSStateSettings(prev => ({
				...prev,
				[filterNames.mapStateBLSYear]: evnt,
			}));
		}
	}, []);

	async function drilldownFunc(e) {
		if (!e.seriesOptions && !isParent) {
			var chartui = this;
			const topology = await fetch(
				`https://code.highcharts.com/mapdata/countries/us/${
					e.point.properties['hc-key']
				}-all.geo.json`
			).then(response => response.json());
			const data = Highcharts.geojson(topology);

			const newData = data.map(data => {
				const foundObj = blsStateDrilldownData.find(
					obj => obj.countY_FIPS === Number(data.properties.fips)
				);
				if (foundObj !== undefined) {
					foundObj.value = foundObj.avG_H_MEDIAN;
					foundObj.tooltip = generateToolTip(foundObj)
						.filter(data => data && data.name)
						.filter(data => data.name !== 'drilldown')
						.filter(data => data.name !== 'value');
					return { ...data, ...foundObj };
				}
				return { ...data, value: null };
			});

			chartui.addSeriesAsDrilldown(e.point, {
				name: e.point.name,
				data: newData,
				joinBy: ['fips', 'county_fips'],
				tooltip: {
					valueSuffix: '%',
				},
				shadow: false,
				color: 'black',
				borderWidth: 1,
				accessibility: {
					enabled: true,
				},
			});
			chartui.redraw();
		}
	}
	const getOptions = () => {
		return {
			chart: {
				borderWidth: 0,
				style: { fontFamily: 'Roboto' },
				height: chartheight,
				spacingBottom: 0,
				spacingTop: 0,
				events: {
					drilldown: drilldownFunc,
				},
			},
			exporting: { enabled: false, allowHTML: true },
			credits: { enabled: false },
			title: {
				text: '',
				align: 'left',
			},
			boost: {
				useGPUTranslations: true,
			},

			mapNavigation: {
				enabled: false,
				enableMouseWheelZoom: true,
			},

			legend: {
				title: {
					text:
						'<span style="font-weight:lighter;font-size:11px">Average H Median</span>',
				},
				x: -10,
			},
			plotOptions: {
				mapline: {
					showInLegend: false,
					enableMouseTracking: false,
				},
			},
			tooltip: {
				shared: true,
				useHTML: true,
				backgroundColor: 'rgba(255,255,255, 0.9)',
				borderWidth: 0,
				borderRadius: 2,
				outside: true,
				formatter: function() {
					const { point } = this;

					return renderToString(<Tooltip tooltipData={point?.tooltip} />);
				},
			},

			series: [
				{
					data: chartData,
					name: 'USA',
					tooltip: {
						valueSuffix: '%',
					},
					shadow: false,
					color: 'white',
					borderWidth: 1,
					accessibility: {
						enabled: true,
					},
				},
			],
			drilldown: {
				activeDataLabelStyle: {
					color: 'white',
					textDecoration: 'none',
					textOutline: '1px #000000',
				},
				breadcrumbs: {
					floating: true,
					relativeTo: 'spacingBox',
				},
				drillUpButton: {
					relativeTo: 'spacingBox',
					position: {
						x: 12,
						y: 60,
					},
				},
			},

			colors: ['#032E45', '#448EB4', '#45B9F7', '#AFE1FC'],
			animation: false,
		};
	};
	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
				{isParent && (
					<ExploreButton
						title="Explore"
						className="explore"
						onClick={() => setIsExpandedView(true)}
					>
						<ApIcon title="Explore" material={true} iconName="find_in_page" />
					</ExploreButton>
				)}
			</Header>
			{!isParent && (
				<div style={{ display: 'flex' }}>
					<MultiSelectWrapper>
						<CategoryMultiSelect
							name="Worker type"
							options={newState.workerTypeOptions}
							selected={blsStateSettings.mapStateWorkerType}
							label="Worker type"
							onChange={e => handleChange(e, 'workerType', 'mapstates')}
						/>
					</MultiSelectWrapper>

					<MultiSelectWrapper>
						<CategoryMultiSelect
							name="BLS Year"
							onChange={e => handleChange(e, 'blsyear', 'mapstates')}
							options={newState.blsYearOptions}
							selected={blsStateSettings.mapStateBLSYear}
							label="BLS Year"
						/>
					</MultiSelectWrapper>
					<ApButtonSecondary
						onClick={() => {
							const obj = {};
							for (const key in blsStateSettings) {
								if (
									Array.isArray(blsStateSettings[key]) &&
									blsStateSettings[key].length > 0
								) {
									obj[key] = blsStateSettings[key];
								}
							}
							setMultipleFilters(obj);
						}}
						style={{ marginLeft: 'auto' }}
					>
						Save
					</ApButtonSecondary>
				</div>
			)}
			{blsstateLoading === true ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{chartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							{joinBy && (
								<>
									<HighchartsReact
										highcharts={Highcharts}
										options={{
											...getOptions(),
											colorAxis: {
												min: _
													.minBy(chartData, 'avG_H_MEDIAN')
													.avG_H_MEDIAN.toFixed(2),
												max: _
													.maxBy(chartData, 'avG_H_MEDIAN')
													.avG_H_MEDIAN.toFixed(2),
												tickInterval:
													_.maxBy(chartData, 'avG_H_MEDIAN').avG_H_MEDIAN / 5,
												stops: [
													[0.3, '#22763f'],
													[0.5, '#fee401'],
													[0.7, '#be2a3e'],
												],
												labels: {
													formatter: function() {
														return Highcharts.numberFormat(this.value, 0); // Format labels with two decimal points
													},
												},
											},
										}}
										constructorType="mapChart"
										ref={chartRef}
										updateArgs={[true, true, false]}
									/>
									{isExpandedView && (
										<ExpandedModal
											heading={chartTitle}
											show={true}
											handleClose={() => setIsExpandedView(state => !state)}
										>
											<BLSMsa
												chartheight={'31%'}
												chartData={chartData}
												blsStateDrilldownData={blsStateDrilldownData}
											/>
										</ExpandedModal>
									)}
								</>
							)}
						</>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default React.memo(BLSMsa);
